"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UserSchema", {
  enumerable: true,
  get: function get() {
    return _User.default;
  }
});
Object.defineProperty(exports, "ItemSchema", {
  enumerable: true,
  get: function get() {
    return _Item.default;
  }
});
Object.defineProperty(exports, "RentalSchema", {
  enumerable: true,
  get: function get() {
    return _Rental.default;
  }
});
Object.defineProperty(exports, "ReviewSchema", {
  enumerable: true,
  get: function get() {
    return _Review.default;
  }
});
Object.defineProperty(exports, "MessageSchema", {
  enumerable: true,
  get: function get() {
    return _Message.default;
  }
});
Object.defineProperty(exports, "NotificationSchema", {
  enumerable: true,
  get: function get() {
    return _Notification.default;
  }
});
exports.collectionMap = void 0;

var _User = _interopRequireDefault(require("./User"));

var _Item = _interopRequireDefault(require("./Item"));

var _Rental = _interopRequireDefault(require("./Rental"));

var _Review = _interopRequireDefault(require("./Review"));

var _Message = _interopRequireDefault(require("./Message"));

var _Notification = _interopRequireDefault(require("./Notification"));

var _enums = require("../enums");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const collectionMap = {
  [_enums.COLLECTIONS.USERS]: _User.default,
  [_enums.COLLECTIONS.ITEMS]: _Item.default,
  [_enums.COLLECTIONS.RENTALS]: _Rental.default,
  [_enums.COLLECTIONS.REVIEWS]: _Review.default,
  [_enums.COLLECTIONS.MESSAGES]: _Message.default,
  [_enums.COLLECTIONS.USER_REVIEWS]: _Review.default,
  [_enums.COLLECTIONS.ITEM_REVIEWS]: _Review.default,
  [_enums.COLLECTIONS.NOTIFICATIONS]: _Notification.default
};
exports.collectionMap = collectionMap;
//# sourceMappingURL=index.js.map